import { render } from "./AboutSettings.vue?vue&type=template&id=6b76df12&scoped=true"
import script from "./AboutSettings.vue?vue&type=script&lang=js"
export * from "./AboutSettings.vue?vue&type=script&lang=js"

import "./AboutSettings.vue?vue&type=style&index=0&id=6b76df12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b76df12"]])

export default __exports__